import React from "react";

const Header = () => (
  <header>
    <h1>Wasif Hyder</h1>
    <nav>
      <ul>
        <li>Home</li>
        <li>About</li>
        <li>Resume</li>
      </ul>
    </nav>
  </header>
);

export default Header;
